import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import { Tooltip } from "@avenue-8/sidekick-ui";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { useCopyText } from "@shared/hooks/useCopyText";

const ICON_SIZE_PX = 16;

type CopyIconButtonProps = {
  text: string;
  ariaLabel?: string;
  className?: string;
};

export const CopyIconButton = ({
  text,
  ariaLabel = "Copy to clipboard",
  className,
}: CopyIconButtonProps) => {
  const { handleCopyText, isCopied } = useCopyText();

  return (
    <Tooltip title={isCopied ? "Copied!" : "Click to copy"}>
      <StyledIconButton
        className={className}
        size="small"
        aria-label={ariaLabel}
        onClick={(event) => {
          event.stopPropagation();
          handleCopyText(text);
        }}
      >
        {isCopied ? (
          <CheckIcon sx={{ fontSize: ICON_SIZE_PX }} color="success" />
        ) : (
          <ContentCopyIcon sx={{ fontSize: ICON_SIZE_PX }} />
        )}
      </StyledIconButton>
    </Tooltip>
  );
};

const StyledIconButton = styled(IconButton)`
  flex-shrink: 0;
  padding: 0.125rem;
`;
